export default __webpack_public_path__ + "static/media/beneficios-buscar-termos.026b80e9.png";